define('GameDayCore/GDModel/load/manager/HeartbeatItem',['require','exports','module','./HeartbeatWorker'],function(require, exports, module) {

	var HeartbeatWorker = require( "./HeartbeatWorker" );

	function HeartbeatItem(gameid, gameItem) {
		this.worker = new HeartbeatWorker(gameid,gameItem);
	}
	/**
	 * API
	 */
	HeartbeatItem.prototype = {
		/**
		 * Function init
		 * @param initLoads {Array} list of base files requested for 'ready' state
		 *
		 * stores initLoad arraay
		 * initiates a load of linescore to see gamestate
		 *
		 */
		init: function() {
			this.worker.init();
		},
		/**
		 * Function start
		 *
		 * creates the heartbeat interval that will call the loads and initiates first Load
		 */
		start : function() {
			this.worker.start();
		},
		/**
		 * Function pause
		 *
		 * stops the heartbeat interval without setting active to false
		 */
		pause : function() {
			this.worker.pause();
		},
		/**
		 * Function stop
		 *
		 * stops the heartbeat interval *and* sets active to false
		 */
		stop : function() {
			this.worker.stop();
		},

		/**
		 * Function isActive
		 * @returns {Boolean}
		 *
		 * getter for the active var
		 */
		isActive : function() {
			return this.worker.isActive();
		}
	};

	return HeartbeatItem;
});
